class HomepageLightbox {
  constructor() {
    this.videoData = null;
    this.lightbox = null;
    this.autoCloseTimer = null;
    this.init();
  }

  init() {
    // Get video data from the page
    this.videoData = this.getVideoData();
    
    if (!this.videoData || !this.videoData.url) {
      console.log('No video data found - lightbox will not launch');
      return;
    }

    // Initialize GLightbox
    this.initGLightbox();
    
    // Auto-launch video after 2 seconds
    setTimeout(() => {
      this.launchVideo();
    }, 1000);
  }

  getVideoData() {
    // Check for video data from the global variable set in front-page.blade.php
    if (window.homepageVideoData && window.homepageVideoData.url) {
      return {
        url: window.homepageVideoData.url,
        autoClose: window.homepageVideoData.autoClose || true,
        autoCloseTime: 4 // Set to 6 seconds to match 5.5 second video
      };
    }
    
    // Fallback: check for DOM element
    const videoElement = document.getElementById('homepage-video-data');
    if (videoElement) {
      return {
        url: videoElement.dataset.videoUrl,
        autoClose: videoElement.dataset.autoClose === 'true',
        autoCloseTime: parseInt(videoElement.dataset.autoCloseTime) || 6
      };
    }
    
    return null;
  }

  initGLightbox() {
    this.lightbox = GLightbox({
      elements: [{
        href: this.videoData.url,
        type: 'video',
        source: 'local'
      }],
      touchNavigation: false,
      loop: false,
      autoplayVideos: true,
      videosWidth: '100%',
      plyr: {
        config: {
          controls: [], // No controls
          autoplay: true,
          muted: true,
          hideControls: true,
          clickToPlay: false,
          disableContextMenu: true,
          keyboard: { focused: false, global: false }
        }
      }
    });
  }

  launchVideo() {
    if (this.lightbox) {
      this.lightbox.open();
      
      // Force autoplay and hide controls after lightbox opens
      setTimeout(() => {
        const video = document.querySelector('.glightbox-container video');
        if (video) {
          video.muted = true;
          video.autoplay = true;
          video.controls = false;
          video.play().catch(e => console.log('Autoplay prevented:', e));
          
          // Hide any control elements
          const controls = document.querySelectorAll('.plyr__controls, .plyr__control');
          controls.forEach(control => control.style.display = 'none');
        }
      }, 100);
      
      // Set up auto-close if enabled
      if (this.videoData.autoClose) {
        this.setupAutoClose();
      }
    }
  }

  setupAutoClose() {
    const closeTime = this.videoData.autoCloseTime * 1000; // Convert to milliseconds
    
    this.autoCloseTimer = setTimeout(() => {
      if (this.lightbox) {
        this.lightbox.close();
      }
    }, closeTime);
  }

  destroy() {
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
    }
    if (this.lightbox) {
      this.lightbox.destroy();
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new HomepageLightbox();
});


// WEBPACK FOOTER //
// ./scripts/components/homepage_lightbox.js